import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Store } from './store';
import List from './List';
import ReplyModal from './ReplyModal';

const Comments = ({ subjectId, replyId, allowComment = true }) => {
    return (
        <Store.Provider>
            <List subjectId={subjectId} replyId={replyId} allowComment={allowComment} />
            <ReplyModal allowComment={allowComment} />
        </Store.Provider>
    );
};

Comments.propTypes = {
    subjectId: PropTypes.string,
    replyId: PropTypes.string,
    allowComment: PropTypes.bool,
};

export default errorBoundary(Comments);
